<template>
  <rich-button @click="commands.heading({ level: 1 })" v-bind:isActive="isActive.heading({ level: 1 })" v-bind:icon="'h1'" />
</template>

<script>
  import H1Button from './H1Button.ts'
  export default H1Button
</script>
